export const PATH_INTERVENTIONS_INTRO = '/interventions/intro';
export const PATH_INTERVENTIONS = '/interventions';
export const PATH_SINGLE_INTERVENTION =
    '/interventions/:date([0-9]{4}-[0-9]{2}-[0-9]{2})';
